export function normalizeCategories(categoriesData) {
  const rawCategories = Array.isArray(categoriesData)
    ? categoriesData
    : categoriesData?.categories || categoriesData?.data || [];

  const toSlug = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  return rawCategories
    .filter((item) => item && (item.slug || item.name))
    .map((item) => ({
      ...item,
      slug: item.slug || toSlug(item.name),
    }));
}
